module.exports = __webpack_public_path__ + "img/manual-holiday-02-add-holiday.de88b3a0.png";